<template>
  <div class="flex-row gap-xxs circles">
    <a-tooltip placement="left" v-for="(status,index) in cellProps" :key="index">
      <template slot="title">
        <span v-text="makeTitle(status, index)"></span>
      </template>
      <div :class="makeClass(status,index)"></div>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    cellProps: {
      type: Array,
    },
  },
  methods: {
    makeTitle(status, index) {
      let t = 'Taak ' + (index + 1) + ' '

      if (status === "canceled") {
        t += "geannuleerd";
      } else if (status === "active") {
        t += "actief";
      } else if (status === "completed") {
        t += "afgerond";
      } else {
        t += "ingepland";
      }


      return t;
    },
    makeClass(status, index) {
      let c = "circle ";

      if (status === "canceled") {
        c += "bg-color-light-red";
      } else if (status === "active") {
        c += "bg-color-primary";
      } else if (status === "completed") {
        c += "bg-color-success";
      } else {
        c += "bg-color-black-transparent";
      }


      if (index === 0) {
        c += ' first-circle'
      }
      if (index === (this.cellProps.length - 1)) {
        c += ' last-circle'
      }

      return c;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/_default.scss';

.first-circle {
  border-top-left-radius: $spacing-xxs;
  border-bottom-left-radius: $spacing-xxs;
}
.last-circle {
  border-top-right-radius: $spacing-xxs;
  border-bottom-right-radius: $spacing-xxs;
}

.circle {
  width: 24px;
  height: 16px;
}

.bg-color-light-red {
  background-color: indianred;
}
</style>
